import { NON_DIGITS_REGEX } from '../regex';
import { INVALID, VALID, NOT_SURE } from './constants';
import BANKS from './bank-codes/se';
var BANK_ACCOUNT_MIN_LENGTH = 10;
var BANK_ACCOUNT_MAX_LENGTH = 16;
var BANK_CLEARING_MIN_LENGTH = 4;
var BANK_CLEARING_MAX_LENGTH = 5;
var format = function format(clearingNumber, accountNumber, bankName) {
  return "".concat(clearingNumber, "-").concat(accountNumber, " ").concat(bankName);
};
var getAccountNumber = function getAccountNumber(bank, paymentNumber) {
  var firstDigit = paymentNumber.charAt(0);
  if (bank.type === 1) {
    return paymentNumber.substr(-7);
  }
  if (bank.type === 2 && bank.comment === 2) {
    return paymentNumber.substring(4);
  }
  if (bank.type === 2 && bank.comment === 3 && firstDigit === '8') {
    return paymentNumber.substring(5);
  }
  if (bank.type === 2 && bank.comment === 3 && firstDigit === '9') {
    return paymentNumber.substring(4);
  }
  return paymentNumber.substr(-10);
};
var getClearingNumber = function getClearingNumber(accountNumber) {
  var endIndex = accountNumber.charAt(0) === '8' ? 5 : 4;
  return accountNumber.substr(0, endIndex);
};

// Runs the mod10 algorithm on the bank account number
var mod10 = function mod10(number) {
  var weights = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  var len = number.length;
  var bit = 1;
  var sum = 0;
  var val;
  while (len) {
    // eslint-disable-next-line no-plusplus
    val = parseInt(number.charAt(--len), 10);
    // eslint-disable-next-line no-cond-assign, no-bitwise
    sum += (bit ^= 1) ? weights[val] : val;
  }
  return sum && sum % 10 === 0;
};

// Runs the mod11 algorithm on the bank account number
function mod11(number) {
  var len = number.length;
  var sum = 0;
  var weights = [1, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  var val;
  var arr = weights.splice(weights.length - len, weights.length - (weights.length - len));
  while (len) {
    // eslint-disable-next-line no-plusplus
    val = parseInt(number.charAt(--len), 10);
    sum += arr[len] * val;
  }
  return sum && sum % 11 === 0;
}
var isValidAccountNumber = function isValidAccountNumber(bank, paymentNumber, accountNumber) {
  var modResult = false;
  if (bank.type === 1 && bank.comment === 1) {
    modResult = mod11(paymentNumber.substr(-10));
  } else if (bank.type === 1 && bank.comment === 2) {
    modResult = mod11(paymentNumber);
  } else if (bank.type === 2 && bank.comment === 2) {
    modResult = mod11(accountNumber.substr(-9));
  } else {
    modResult = mod10(accountNumber);
  }
  if (modResult) {
    return VALID;
  }
  if (bank.ignoresValidation) {
    return NOT_SURE;
  }
  return INVALID;
};
var parseClearingNumber = function parseClearingNumber(clearingNumber) {
  var result = {
    bank: null,
    valid: INVALID,
    error: {
      type: null,
      message: null
    }
  };
  var sanitized = clearingNumber.replace(NON_DIGITS_REGEX, '');
  if (sanitized.length < BANK_CLEARING_MIN_LENGTH || sanitized.length > BANK_CLEARING_MAX_LENGTH) {
    return result;
  }
  var bank = BANKS.find(function (value) {
    var regex = new RegExp(value.clearingRegex);
    return regex.test(sanitized);
  });
  if (!bank) {
    return result;
  }
  result.bank = bank;
  result.clearingNumber = clearingNumber;
  result.valid = VALID;
  return result;
};
var parse = function parse(bankAccount) {
  var result = {
    bank: null,
    accountNumber: '',
    clearingNumber: '',
    bankAccount: '',
    valid: INVALID,
    formatted: '',
    error: {
      type: 'genericError',
      message: "Invalid bank account: ".concat(bankAccount)
    }
  };
  var sanitized = bankAccount.replace(NON_DIGITS_REGEX, '');
  if (sanitized.length < BANK_ACCOUNT_MIN_LENGTH || sanitized.length > BANK_ACCOUNT_MAX_LENGTH) {
    result.error.type = 'length';
    result.error.message = "Invalid bank account length: ".concat(bankAccount);
    return result;
  }
  var clearingNumber = getClearingNumber(sanitized);
  var _parseClearingNumber = parseClearingNumber(clearingNumber),
    bank = _parseClearingNumber.bank,
    valid = _parseClearingNumber.valid;
  if (valid === INVALID) {
    return result;
  }
  var regex = new RegExp(bank.clearingRegex + bank.regex);
  if (!regex.test(sanitized)) {
    return result;
  }
  var accountNumber = getAccountNumber(bank, sanitized.replace(bank.clearingRegex, ''));
  result.bankAccount = sanitized;
  result.accountNumber = accountNumber;
  result.clearingNumber = clearingNumber;
  result.bank = bank;
  result.valid = isValidAccountNumber(bank, sanitized, accountNumber);
  result.formatted = format(result.clearingNumber, result.accountNumber, result.bank.name);
  if (result.valid === VALID || result.valid === NOT_SURE) {
    result.error.type = null;
    result.error.message = null;
  }
  return result;
};
export default parse;